// extracted by css-extract-rspack-plugin
export default {"cls1":"ConfirmationBanner-cls1_v8b","cls2":"ConfirmationBanner-cls2_44J ConfirmationBanner-cls1_v8b"};